// Grössen-Buttons: Grid-Spalten dynamisch auf Anzahl Buttons setzen
function initSwatchGrid() {
  document.querySelectorAll('.block-swatch-list').forEach(function(list) {
    var count = list.querySelectorAll('.block-swatch').length;
    list.style.setProperty('--swatch-count', count);
  });
}

document.addEventListener('DOMContentLoaded', initSwatchGrid);

// Auch nach Variant-Wechsel neu initialisieren (falls Shopify die Liste neu rendert)
document.addEventListener('variant:changed', initSwatchGrid);


/* ===================================================================
   MERKLISTE (Stufe 1) — 3RD MAY, 10.–12.09.2026

   Shopify hat keine eingebaute Merkliste. Diese Fassung speichert im
   Browser des Besuchers (localStorage), braucht also weder Login noch
   App noch Server. Grenze: gilt pro Gerät und Browser.

   NUR AUF DER PRODUKTSEITE, bewusst nicht auf den Kachelrastern
   (Entscheid Patrick, 11.09.2026). Zalando und About You setzen das Herz
   auf die Kachel, weil man dort durch tausende Artikel scrollt und im
   Vorbeigehen parken will. 3RD MAY hat 46 Produkte — es gibt kein Raster
   zum Aussortieren, und auf den ruhigen Freistellern ist ein schwebendes
   Herz Störung ohne Gegenwert. SNOCKS, ein vergleichbarer Direktvertrieb,
   hat gar keine Merkliste (am 11.09.2026 geprüft: null Treffer).

   ZURÜCKHALTEND UND OHNE EIGENE ZEILE (Entscheid Patrick, 12.09.2026:
   "das muss dezenter eingebaut werden ... auf einer anderen Ebene mit etwas
   anderem, sodass es nicht mehr so viel Platz braucht"). Das Herz haengt
   rechts in der ohnehin vorhandenen Zeile "Wähle Deine Grösse: S"
   (.product-form__option-info) und kostet damit KEINE zusaetzliche Hoehe.
   Dazu: kleines Symbol, gedämpftes Grau, kleine Schrift, kein Rahmen, kein
   Hüpfen beim Überfahren. Erst wenn der Artikel wirklich gemerkt ist, färbt
   es sich. Die ganze Zeile ist anklickbar, damit das kleinere Symbol kein
   kleineres Ziel bedeutet.

   KEIN UMTAUSCH-HINWEIS AUF DER PRODUKTSEITE (Entscheid Patrick,
   12.09.2026). Hier stand bis zum 12.09. "Grösse unsicher? Umtausch in
   zwei Minuten angemeldet". Begründung für das Entfernen: wer noch nicht
   gekauft hat, soll nicht an die Rücksendung denken. Der Hinweis lenkt vor
   dem Kauf auf ein Problem, das es noch gar nicht gibt. Rückgabe und
   Umtausch gehören in die FAQ und auf die Versandseite — dort stehen sie.

   Stufe 2 (am Kundenkonto, geräteübergreifend) würde nur SPEICHERN und
   LADEN ersetzen — die beiden Funktionen unten sind bewusst die einzige
   Stelle, die dann angefasst werden muss.

   Warum hier und nicht in theme.liquid: custom.js wird auf jeder Seite
   geladen und ist klein. Ein Eingriff in die 62-KB-theme.liquid wäre
   dasselbe Ergebnis bei erheblich mehr Risiko.

   KEINE BACKSLASHES IN DIESER DATEI. Sie geht über die Theme-API hoch,
   und ein Backslash überlebt den Weg nicht — die ganze Datei stirbt dann
   am Syntaxfehler, samt initSwatchGrid oben. Am 10.09. mit einem Regex
   passiert. Also: keine regulären Ausdrücke, keine maskierten Zeichen.
   =================================================================== */
(function () {
  'use strict';

  var SCHLUESSEL = '3rdmay_merkliste';
  var KENNUNG = '3rdmay_mk_v';
  var SEITE = '/pages/merkliste';
  var MELDESTELLE = 'https://countdown.3rdmay.ai/merkliste/ereignis';

  // --- Speicher (Stufe 2 tauscht genau diese zwei Funktionen) ---------
  function laden() {
    try {
      var roh = window.localStorage.getItem(SCHLUESSEL);
      var liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];   // privater Modus, blockierte Speicherung, kaputter Inhalt
    }
  }

  function speichern(liste) {
    try {
      window.localStorage.setItem(SCHLUESSEL, JSON.stringify(liste));
    } catch (e) {
      /* Kein Speicher verfügbar: die Merkliste bleibt für diese Sitzung im DOM,
         geht aber beim Neuladen verloren. Besser als eine Fehlermeldung. */
    }
    document.dispatchEvent(new CustomEvent('merkliste:geaendert', { detail: liste }));
  }

  function gemerkt(handle) { return laden().indexOf(handle) !== -1; }

  function umschalten(handle) {
    var liste = laden();
    var i = liste.indexOf(handle);
    if (i === -1) { liste.push(handle); } else { liste.splice(i, 1); }
    speichern(liste);
    melden(handle, i === -1);
    return i === -1;
  }

  /* --- Auswertung ------------------------------------------------------

     Die Merkliste liegt im Browser, wir saehen also nie, was drauf liegt.
     Deshalb geht bei jedem Herzklick eine Meldung an unseren eigenen Server
     (siehe /opt/merkliste auf dem Hetzner).

     Gemeldet wird NUR: Produkt-Handle, "drauf" oder "runter", und eine
     Zufallskennung, die dieser Browser selbst erzeugt. Keine E-Mail, kein
     Name, keine Bestellung, kein Warenkorb. Die Kennung hat keinerlei Bezug
     zu einer Person — sie dient allein dazu, "eine Person merkt zehn Artikel"
     von "zehn Personen merken je einen" unterscheiden zu koennen.

     sendBeacon, weil die Meldung den Seitenwechsel ueberleben soll und den
     Klick nicht verzoegern darf. Schlaegt sie fehl, merkt der Kunde nichts —
     die Merkliste funktioniert unabhaengig davon weiter. */
  function besucherKennung() {
    try {
      var v = window.localStorage.getItem(KENNUNG);
      if (!v) {
        v = (Math.random().toString(36) + Math.random().toString(36))
              .split('.').join('').slice(0, 20);
        window.localStorage.setItem(KENNUNG, v);
      }
      return v;
    } catch (e) {
      return null;    // kein Speicher -> keine Meldung, das ist in Ordnung
    }
  }

  function melden(handle, drauf) {
    try {
      if (!navigator.sendBeacon) return;
      var v = besucherKennung();
      if (!v) return;
      var last = JSON.stringify({ h: handle, a: drauf ? 'add' : 'del', v: v });
      navigator.sendBeacon(MELDESTELLE, new Blob([last], { type: 'text/plain' }));
    } catch (e) {
      /* Werbeblocker, offline, Beacon abgelehnt — alles egal, der Shop laeuft. */
    }
  }

  // --- Hilfen ---------------------------------------------------------
  function handleAus(url) {
    if (!url) return null;
    var s = String(url);
    var i = s.indexOf('/products/');
    if (i === -1) return null;
    var rest = s.slice(i + 10);
    rest = rest.split('?')[0].split('#')[0].split('/')[0];
    return rest ? decodeURIComponent(rest) : null;
  }

  function herzSvg(gefuellt) {
    return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">'
      + '<path d="M12 20.7 4.2 13a4.8 4.8 0 0 1 0-6.8 4.8 4.8 0 0 1 6.8 0l1 1 1-1a4.8 4.8 0 0 1 6.8 0 '
      + '4.8 4.8 0 0 1 0 6.8Z" fill="' + (gefuellt ? 'currentColor' : 'none')
      + '" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  }

  function knopfBauen(handle, klasse) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mk-herz ' + (klasse || '');
    b.setAttribute('data-mk-handle', handle);
    zeichnen(b, gemerkt(handle));
    return b;
  }

  function zeichnen(knopf, an) {
    knopf.innerHTML = herzSvg(an);
    knopf.setAttribute('aria-pressed', an ? 'true' : 'false');
    knopf.setAttribute('aria-label', an ? 'Von der Merkliste entfernen' : 'Auf die Merkliste');
    knopf.setAttribute('title', an ? 'Von der Merkliste entfernen' : 'Auf die Merkliste');
    knopf.classList.toggle('is-an', an);
  }

  /* --- Die richtige Kaufleiste finden ---------------------------------

     Die PDP hat ZWEI Elemente mit .product-form__add-button: eines im
     Hauptformular und eines in der klebenden Leiste, die erst beim Scrollen
     erscheint. querySelector nimmt die klebende zuerst — dort landeten Herz
     und Umtauschzeile bis zum 11.09.2026 unsichtbar (visibility:hidden,
     Breite 0). Deshalb wird die klebende Leiste hier ausdrücklich
     uebersprungen. */
  function pdpZeile() {
    if (location.pathname.indexOf('/products/') === -1) return null;
    var knoepfe = document.querySelectorAll('.product-form__add-button');
    for (var i = 0; i < knoepfe.length; i++) {
      var k = knoepfe[i];
      if (k.closest('product-sticky-form, .product-sticky-form, .ed-product-sticky-form')) continue;
      var reihe = k.closest('.product-form__buy-buttons')
               || k.closest('.product-form__buttons')
               || k.parentElement;
      if (reihe && reihe.parentElement) return reihe;
    }
    return null;
  }

  /* --- Wohin das Herz gehoert ------------------------------------------

     Erste Wahl: die Zeile "Wähle Deine Grösse: S". Die ist ohnehin da, rechts
     davon ist Platz — das Herz kostet dort keine zusaetzliche Hoehe. Es gibt
     zwei solche Zeilen (Farbe und Grösse); genommen wird die LETZTE, also die
     dichteste am Kaufbutton.

     Rueckfallebene: eigene Zeile unter dem Kaufbutton, wie bis zum 12.09.2026.
     Greift, wenn eine Produktseite gar keine Options-Zeile hat (Einheitsgrösse)
     — dann soll die Merkliste trotzdem da sein. */
  function anker() {
    if (location.pathname.indexOf('/products/') === -1) return null;
    var infos = document.querySelectorAll('.product-form__option-info');
    for (var i = infos.length - 1; i >= 0; i--) {
      if (!infos[i].closest('product-sticky-form, .product-sticky-form, .ed-product-sticky-form')) {
        return { art: 'zeile', knoten: infos[i] };
      }
    }
    var reihe = pdpZeile();
    return reihe ? { art: 'unten', knoten: reihe } : null;
  }

  function beschriftung(handle) {
    return gemerkt(handle) ? 'Gemerkt' : 'Merken';
  }

  function herzAufPdp() {
    if (document.querySelector('.mk-herz--pdp')) return;
    var a = anker();
    if (!a) return;
    var handle = handleAus(location.pathname);
    if (!handle) return;

    var zeile = document.createElement('span');
    zeile.className = 'mk-pdp-zeile' + (a.art === 'unten' ? ' mk-pdp-zeile--unten' : '');
    zeile.appendChild(knopfBauen(handle, 'mk-herz--pdp'));
    var text = document.createElement('span');
    text.className = 'mk-pdp-text';
    text.textContent = beschriftung(handle);
    zeile.appendChild(text);

    if (a.art === 'zeile') {
      a.knoten.appendChild(zeile);
    } else {
      a.knoten.parentElement.insertBefore(zeile, a.knoten.nextSibling);
    }
  }

  // --- Zähler im Kopf ---------------------------------------------------
  function zaehlerSetzen() {
    var n = laden().length;
    var link = document.querySelector('.mk-kopf-link');
    if (!link) {
      var warenkorb = document.querySelector('a[href="/cart"]');
      if (!warenkorb || !warenkorb.parentElement) return;
      link = document.createElement('a');
      link.className = 'mk-kopf-link';
      link.href = SEITE;
      link.setAttribute('aria-label', 'Merkliste');
      warenkorb.parentElement.insertBefore(link, warenkorb);
    }
    link.innerHTML = herzSvg(n > 0) + (n > 0 ? '<span class="mk-zahl">' + n + '</span>' : '');
    link.style.display = n > 0 ? '' : 'none';   // erst zeigen, wenn etwas drin ist
  }

  // --- Die Merklisten-Seite ---------------------------------------------
  function seiteFuellen() {
    var ziel = document.getElementById('merkliste');
    if (!ziel) return;
    var liste = laden();
    if (!liste.length) {
      ziel.innerHTML = '<p class="mk-leer">Deine Merkliste ist noch leer. '
        + 'Tippe auf der Produktseite auf das Herz, dann findest Du den Artikel hier wieder.</p>'
        + '<p><a class="button button--primary" href="/collections/all">Zu den Produkten</a></p>';
      return;
    }
    ziel.innerHTML = '<p class="mk-leer">Einen Moment …</p>';
    Promise.all(liste.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (produkte) {
      var gueltig = [];
      var html = '';
      produkte.forEach(function (p, i) {
        if (!p) return;                       // Produkt gelöscht -> still aus der Liste
        gueltig.push(liste[i]);
        var bild = p.featured_image ? p.featured_image + '&width=600' : '';
        var preis = (p.price / 100).toFixed(2);
        var titelSicher = String(p.title).split('"').join('&quot;');
        html += '<article class="mk-eintrag">'
          + '<a href="/products/' + p.handle + '">'
          + (bild ? '<img src="' + bild + '" alt="' + titelSicher + '" loading="lazy">' : '')
          + '</a>'
          + '<div class="mk-eintrag__text">'
          + '<a class="mk-eintrag__titel" href="/products/' + p.handle + '">' + p.title + '</a>'
          + '<span class="mk-eintrag__preis">CHF ' + preis + '</span>'
          + '<button type="button" class="mk-entfernen" data-mk-handle="' + p.handle + '">Entfernen</button>'
          + '</div></article>';
      });
      if (gueltig.length !== liste.length) speichern(gueltig);
      ziel.innerHTML = html || '<p class="mk-leer">Deine gemerkten Artikel sind nicht mehr verfügbar.</p>';
    });
  }

  /* --- Stil (hier statt in custom.css, damit nur eine Datei berührt wird)

     Die Zeile auf der Produktseite ist absichtlich leise: 15px statt 20px,
     Grauton statt Schwarz, 0.78rem Schrift, kein Rahmen, kein Hüpfen.
     Farbe bekommt sie erst, wenn der Artikel wirklich gemerkt ist — das ist
     dann eine Rückmeldung und keine Werbung. */
  function stil() {
    if (document.getElementById('mk-stil')) return;
    var s = document.createElement('style');
    s.id = 'mk-stil';
    s.textContent = [
      '.mk-herz{background:none;border:0;padding:6px;cursor:pointer;color:inherit;line-height:0}',
      '.mk-herz.is-an{color:#801818}',
      // In der Optionszeile: margin-left:auto schiebt das Herz nach rechts, die
      // Zeile bleibt 24px hoch wie vorher. Kein zusaetzlicher Platzbedarf.
      '.mk-pdp-zeile{display:inline-flex;align-items:center;gap:.3rem;margin-left:auto;',
      '  color:rgba(0,0,0,.48);transition:color .15s ease}',
      // Rueckfallebene unter dem Kaufbutton: dort ist die Elternbox ein GRID und
      // wuerde die Zeile auf volle Spaltenbreite ziehen — dann reagiert sie auf
      // Mausbewegungen weit rechts vom Text.
      '.mk-pdp-zeile--unten{margin:.85rem 0 0;justify-self:start;align-self:start;',
      '  width:fit-content}',
      '.mk-pdp-zeile:hover{color:rgba(0,0,0,.78)}',
      '.mk-pdp-zeile .mk-herz{padding:2px}',
      '.mk-pdp-zeile .mk-herz svg{width:15px;height:15px}',
      '.mk-pdp-zeile .mk-herz.is-an{color:#801818}',
      '.mk-pdp-text{font-size:.78rem;letter-spacing:.01em;cursor:pointer;user-select:none}',
      '.mk-kopf-link{display:inline-flex;align-items:center;gap:.25rem;color:inherit;position:relative}',
      '.mk-zahl{font-size:.75rem;line-height:1}',
      '.mk-eintrag{display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid #d3d2cb}',
      '.mk-eintrag img{width:110px;height:auto;display:block}',
      '.mk-eintrag__text{display:flex;flex-direction:column;gap:.3rem;justify-content:center}',
      '.mk-eintrag__titel{font-weight:600;text-decoration:none;color:inherit}',
      '.mk-entfernen{align-self:flex-start;background:none;border:0;padding:0;cursor:pointer;',
      '  text-decoration:underline;font-size:.85rem;color:inherit}',
      '.mk-leer{margin:1.5rem 0}',
      '@media(max-width:480px){.mk-eintrag img{width:84px}}'
    ].join('');
    document.head.appendChild(s);
  }

  // --- Verdrahtung -------------------------------------------------------
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Der Text ist kein Knopf, soll aber wie einer wirken: das kleinere
    // Symbol darf kein kleineres Ziel bedeuten.
    var beschriftung = e.target.closest('.mk-pdp-text');
    if (beschriftung) {
      var dazu = document.querySelector('.mk-herz--pdp');
      if (dazu) dazu.click();
      return;
    }

    var herz = e.target.closest('.mk-herz');
    if (herz) {
      e.preventDefault();
      e.stopPropagation();
      var h = herz.getAttribute('data-mk-handle');
      var an = umschalten(h);
      document.querySelectorAll('.mk-herz').forEach(function (k) {
        if (k.getAttribute('data-mk-handle') === h) zeichnen(k, an);
      });
      var t = document.querySelector('.mk-pdp-text');
      if (t && herz.classList.contains('mk-herz--pdp')) {
        t.textContent = an ? 'Gemerkt' : 'Merken';
      }
      return;
    }

    var weg = e.target.closest('.mk-entfernen');
    if (weg) {
      umschalten(weg.getAttribute('data-mk-handle'));
      seiteFuellen();
    }
  });

  document.addEventListener('merkliste:geaendert', zaehlerSetzen);

  // Shopify schreibt die Optionszeile beim Variantenwechsel neu. herzAufPdp
  // bricht sofort ab, wenn das Herz noch steht — der Aufruf ist also billig
  // und holt es zurueck, falls es weggerendert wurde.
  document.addEventListener('variant:changed', herzAufPdp);

  function start() {
    stil();
    herzAufPdp();
    zaehlerSetzen();
    seiteFuellen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();